'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  content: {
    input: {
      placeHolder: 'Search for jobs by keyword'
    },
    country: {
      options: [{
        value: '',
        label: 'Countries/Regions'
      }, {
        value: 'us',
        label: 'United States'
      }, {
        value: 'au',
        label: 'Australia'
      }, {
        value: 'be',
        label: 'Belgium'
      }, {
        value: 'br',
        label: 'Brazil'
      }, {
        value: 'ca',
        label: 'Canada'
      }, {
        value: 'cn',
        label: 'China'
      }, {
        value: 'fr',
        label: 'France'
      }, {
        value: 'de',
        label: 'Germany'
      }, {
        value: 'gt',
        label: 'Guatemala'
      }, {
        value: 'hk',
        label: 'Hong Kong'
      }, {
        value: 'in',
        label: 'India'
      }, {
        value: 'ie',
        label: 'Ireland'
      }, {
        value: 'il',
        label: 'Israel'
      }, {
        value: 'it',
        label: 'Italy'
      }, {
        value: 'jp',
        label: 'Japan'
      }, {
        value: 'lu',
        label: 'Luxembourg'
      }, {
        value: 'mx',
        label: 'Mexico'
      }, {
        value: 'nl',
        label: 'Netherlands'
      }, {
        value: 'ph',
        label: 'Philippines'
      }, {
        value: 'pl',
        label: 'Poland'
      }, {
        value: 'ru',
        label: 'Russian Federation'
      }, {
        value: 'sg',
        label: 'Singapore'
      }, {
        value: 'es',
        label: 'Spain'
      }, {
        value: 'se',
        label: 'Sweden'
      }, {
        value: 'ch',
        label: 'Switzerland'
      }, {
        value: 'tw',
        label: 'Taiwan'
      }, {
        value: 'th',
        label: 'Thailand'
      }, {
        value: 'tr',
        label: 'Turkey'
      }, {
        value: 'uk',
        label: 'United Kingdom'
      }]
    },
    cities: {
      option: {
        label: 'All Cities'
      },
      optionGroup: [{
        country: 'United States',
        code: 'us',
        city: [{
          value: 'Austin',
          label: 'Austin'
        }, {
          value: 'Boston',
          label: 'Boston'
        }, {
          value: 'Chandler',
          label: 'Chandler'
        }, {
          value: 'Chicago',
          label: 'Chicago'
        }, {
          value: 'Conshohocken',
          label: 'Conshohocken'
        }, {
          value: 'Denver',
          label: 'Denver'
        }, {
          value: 'Miami',
          label: 'Miami'
        }, {
          value: 'New York',
          label: 'New York'
        }, {
          value: 'Newton',
          label: 'Newton'
        }, {
          value: 'Omaha',
          label: 'Omaha'
        }, {
          value: 'Salt Lake City',
          label: 'Salt Lake City'
        }, {
          value: 'San Francisco',
          label: 'San Francisco'
        }, {
          value: 'San Jose',
          label: 'San Jose'
        }, {
          value: 'Scottsdale',
          label: 'Scottsdale'
        }, {
          value: 'Timonium',
          label: 'Timonium'
        }, {
          value: 'Washington, DC',
          label: 'Washington, DC'
        }, {
          value: 'Wilmington, DE',
          label: 'Wilmington'
        }]
      }, {
        country: 'Australia',
        code: 'au',
        city: [{
          value: 'Sydney',
          label: 'Sydney'
        }]
      }, {
        country: 'Belgium',
        code: 'be',
        city: [{
          value: 'Brussels',
          label: 'Brussels'
        }]
      }, {
        country: 'Brazil',
        code: 'br',
        city: [{
          value: 'Sao Paulo',
          label: 'Sao Paulo'
        }]
      }, {
        country: 'Canada',
        code: 'ca',
        city: [{
          value: 'Toronto',
          label: 'Toronto'
        }, {
          value: 'Vancouver',
          label: 'Vancouver'
        }]
      }, {
        country: 'China',
        code: 'cn',
        city: [{
          value: 'Beijing',
          label: 'Beijing'
        }, {
          value: 'Shanghai',
          label: 'Shanghai'
        }]
      }, {
        country: 'France',
        code: 'fr',
        city: [{
          value: 'Paris',
          label: 'Paris'
        }]
      }, {
        country: 'Germany',
        code: 'de',
        city: [{
          value: 'Berlin',
          label: 'Berlin'
        }]
      }, {
        country: 'Guatemala',
        code: 'gt',
        city: [{
          value: 'Guatemala City, Guatemala',
          label: 'Guatemala City'
        }]
      }, {
        country: 'India',
        code: 'in',
        city: [{
          value: 'Bangalore',
          label: 'Bangalore'
        }, {
          value: 'Chennai',
          label: 'Chennai'
        }, {
          value: 'Mumbai',
          label: 'Mumbai'
        }]
      }, {
        country: 'Ireland',
        code: 'ie',
        city: [{
          value: 'Dublin',
          label: 'Dublin'
        }, {
          value: 'Dundalk, Co Louth',
          label: 'Dundalk'
        }]
      }, {
        country: 'Israel',
        code: 'il',
        city: [{
          value: 'Tel Aviv',
          label: 'Tel Aviv'
        }]
      }, {
        country: 'Italy',
        code: 'it',
        city: [{
          value: 'Milan',
          label: 'Milan'
        }]
      }, {
        country: 'Japan',
        code: 'jp',
        city: [{
          value: 'Tokyo',
          label: 'Tokyo'
        }]
      }, {
        country: 'Luxembourg',
        code: 'lu',
        city: [{
          value: 'Luxembourg',
          label: 'Luxembourg'
        }]
      }, {
        country: 'Mexico',
        code: 'mx',
        city: [{
          value: 'Mexico City',
          label: 'Mexico City'
        }]
      }, {
        country: 'Netherlands',
        code: 'nl',
        city: [{
          value: 'Amsterdam',
          label: 'Amsterdam'
        }]
      }, {
        country: 'Philippines',
        code: 'ph',
        city: [{
          value: 'Manila',
          label: 'Manila'
        }]
      }, {
        country: 'Poland',
        code: 'pl',
        city: [{
          value: 'Warszawa',
          label: 'Warszawa'
        }]
      }, {
        country: 'Russian Federation',
        code: 'ru',
        city: [{
          value: 'Moscow',
          label: 'Moscow'
        }]
      }, {
        country: 'Spain',
        code: 'es',
        city: [{
          value: 'Madrid',
          label: 'Madrid'
        }]
      }, {
        country: 'Sweden',
        code: 'se',
        city: [{
          value: 'Stockholm',
          label: 'Stockholm'
        }]
      }, {
        country: 'Switzerland',
        code: 'ch',
        city: [{
          value: 'Geneva',
          label: 'Geneva'
        }]
      }, {
        country: 'Taiwan',
        code: 'tw',
        city: [{
          value: 'Taipei',
          label: 'Taipei'
        }]
      }, {
        country: 'Thailand',
        code: 'th',
        city: [{
          value: 'Bangkok',
          label: 'Bangkok'
        }]
      }, {
        country: 'Turkey',
        code: 'tr',
        city: [{
          value: 'Istanbul',
          label: 'Istanbul'
        }]
      }, {
        country: 'United Kingdom',
        code: 'uk',
        city: [{
          value: 'London',
          label: 'London'
        }]
      }]
    },
    category: {
      options: [{
        value: '',
        label: 'All Categories'
      }, {
        value: 'Administrative Assistant',
        label: 'Administrative Support'
      }, {
        value: 'Marketing Communications',
        label: 'Communications'
      }, {
        value: 'Compliance',
        label: 'Compliance'
      }, {
        value: 'Corporate Development & Strategy',
        label: 'Corporate Development & Strategy'
      }, {
        value: 'Account Management|Collections - CS/Ops|Credit|Credit Underwriting|Customer Care|Customer Contact|Customer Solutions|Customer Support|Fraud Agent|Global Metrics|Operations Support|Partner Mgmt|Payment Operations|Processing Support|Product Integration|Quality Assurance - CS|Risk Operations|Training - Custom Support/Ops|Workforce Management',
        label: 'Customer Care Operations'
      }, {
        value: 'Customer Support|Account Management|Customer Care|Customer Contact|Customer Solutions|Customer Support',
        label: 'Customer Support'
      }, {
        value: 'Data Scientist',
        label: 'Data Science & Analytics'
      }, {
        value: 'Design Engineer|Designer|User Experience Researcher|Content Designer|Content Mgmt',
        label: 'Design & User Experience'
      }, {
        value: 'Facilities Engineer|Facilities Management|Safety & Security',
        label: 'Facilities, Safety & Security'
      }, {
        value: 'Accounting|Accounts Payable|Audit|Billing & Collections|Compliance|Consolidations Accounting|Controller|Finance Management|Finance Project Mgmt|Financial Analyst|Financial Services|Investor Relations|Payroll|Procurement|Quan. Research & Analysis|Tax|Treasury',
        label: 'Finance'
      }, {
        value: 'General Management|Business Process Analyst|Country Manager|Flight Operations|Foundation|Product Specialist|Executive Management',
        label: 'General Management'
      }, {
        value: 'Benefits|Compensation|Employment|HRIS|HR Generalist|HR Support|Learning & Development (Mgmt)|Training - Human Resources',
        label: 'Human Resources'
      }, {
        value: 'Asset Management|Business Process|Business Systems|Desktop Support|Information Management|Information Security|Information Technology Mgmt|IS Technician|Network Security|Network Systems|Storage|Systems Adminstration|Systems Integration|Telecom Engineer|Unix Systems Database Engineer|Engineering Program Mgmt|Language Specialist|Network Engineering|NOC Engineering|Performance & Capacity|Process Engineering|Product Support|Site Operations|Technical Project Mgmt|Technical Services|Technical Support|Technical Systems|Technical Writer',
        label: 'IT & Technical Operations'
      }, {
        value: 'Internship',
        label: 'Internships'
      }, {
        value: 'Contracts Administration|Government Affairs|Legal Affairs|Legal Assistant|Legal Counsel|Paralegal|Stock Administration|Domain Name',
        label: 'Legal'
      }, {
        value: 'Alliance Partnerships|Business Development - Mktng|Category Management|Channel Marketing|Community Development|Community Outreach|Community Specialist|Content Designer|Content Mgmt|Creative Services|Database Marketing|E-Commerce Marketing|Events|Internet Marketing|Market Research|Marketing Communications|Marketing Generalist|Marketing Programs|Marketing Specialist|Merchandising|Product General Management|Product General Management|Product Management|Product Marketing|Product Project Management|Public Relations Specialist|Strategic Alliances|Strategy Development|Web Design',
        label: 'Marketing'
      }, {
        value: 'Technical Product Management|Product Management|Program Product Management|Product General Management|Product Marketing|Product Project Management',
        label: 'Product Management'
      }, {
        value: 'Recent College Graduate',
        label: 'Recent College Graduates'
      }, {
        value: 'Credit Administration|Credit Portfolio|Fraud Prevention|Global Rules|Risk Analytics|Risk Management|Training - Risk|Trust & Safety',
        label: 'Risk Management'
      }, {
        value: 'Ad Sales|Applications Consulting|Business Development - Sales|Client Services|Field Sales|Inside Sales|Inside Sales - Inbound|Inside Sales - Outbound|Key Account Management|Merchant Accounts|Partner Sales|Relationship Management|Sales Administration|Sales Development|Sales Operations|Telesales|Strategy Development|Business Development -Mktng',
        label: 'Sales & Business Development'
      }, {
        value: 'Technical Architect',
        label: 'Software Architecture'
      }, {
        value: 'Software Development',
        label: 'Software Development'
      }, {
        value: 'Software QA',
        label: 'Software QA'
      }, {
        value: 'Product Project Management',
        label: 'Technical Product Management'
      }, {
        value: 'Technical Project Management',
        label: 'Technical Project Management'
      }, {
        value: 'Fraud Prevention|Trust & Safety',
        label: 'Trust, Safety & Fraud'
      }]
    },
    primaryCta: {
      text: 'Search'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/jobs-search/jsx/JobsSearchDefaultProps.js
// module id = 1113
// module chunks = 4